import styles from "./EditContainer.module.scss";

export const EditContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.editContainer}>{children}</div>
);
